import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontSize: 16,
    fontFamily: "Btitr",
  },
  body: {
    fontSize: 19,
    fontFamily: "Bnazanin",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);



const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

export default function CustomizedTables(rows) {
  const classes = useStyles();
  console.log(rows)
  return (
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">عنوان</StyledTableCell>
              <StyledTableCell align="center">تعداد کل اسناد</StyledTableCell>
              <StyledTableCell align="center">تعداد واژه‌های اسناد</StyledTableCell>
              <StyledTableCell align="center">تعداد واژه‌های یکتای اسناد</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { rows ? rows.rows.map((row) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell component="th" scope="row" align="center">
                    {row.name==='زبان' ? 'زبان‌شناسی' : row.name}
                  </StyledTableCell>
                  <StyledTableCell align="center">{row.calories}</StyledTableCell>
                  <StyledTableCell align="center">{row.fat}</StyledTableCell>
                  <StyledTableCell align="center">{row.fat2}</StyledTableCell>
                </StyledTableRow>
            )) : null}
          </TableBody>
        </Table>
      </TableContainer>
  );
}
